export default "__VITE_ASSET__fE9_Hg8H__"